/* eslint-disable @next/next/no-img-element */
import H2 from '@base/H2/H2';
import H4 from '@base/H4/H4';
import { getImage } from '@utils/imageHelper';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { mobile } from '@styles/index';
import { useIsMobile } from '@stores/AppCommonData';
import useAppInstallAnalytics from '@hooks/useAppInstallAnalytics';

const FooterWrapper = styled.div`
  /* height: 70vh; */
  /* margin-bottom: -40px; */
  position: relative;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    height: unset;
  }
`;

const Wrapper = styled.div`
  max-width: 1136px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    max-width: 98%;
    flex-direction: column;
    text-align: center;
  }
  img {
    z-index: 1;
    height: 100%;
  }
`;

const FooterAsset = styled.img`
  z-index: 1;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    height: unset;
    width: 100%;
    margin-top: 64px;
  }
`;

const BGImage = styled.img`
  position: absolute;
  width: 100%;
  z-index: 0;
  bottom: -40px;
`;

const BgImageMobile = styled.img`
  height: unset;
  position: absolute;
  width: 100%;
  bottom: -32px;
`;

const Content = styled.div`
  max-width: 420px;
  z-index: 1;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    max-width: 75%;
  }
  h2 {
    max-width: 380px;
    @media only screen and (max-width: ${mobile.maxWidth}) {
      font-size: 24px;
    }
  }
  h4 {
    color: var(--color-text-secondary);
    font-weight: normal;
    margin: 24px auto;
    @media only screen and (max-width: ${mobile.maxWidth}) {
      font-size: 14px;
    }
  }
`;

const AppsWrapper = styled.div`
  display: flex;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    justify-content: center;
  }
`;

const CombatFooter = ({ goalUID }) => {
  const isMobile = useIsMobile();
  const sendAapInstallAnalytics = useAppInstallAnalytics();
  const { footerData } = useSelector(
    ({ combats }) => combats.staticData[goalUID] || {}
  );
  const handleGooglePlayIconClick = () => {
    sendAapInstallAnalytics({
      button_text: 'GET IT ON Google Play'
    });
  };

  return (
    <FooterWrapper>
      {!isMobile && (
        <BGImage
          src={getImage('combat/bottom-footer.svg')}
          alt="bottom footer cloud"
        />
      )}
      <Wrapper>
        <Content>
          <H2>{footerData.title}</H2>
          <H4>{footerData.subtitle}</H4>
          <AppsWrapper>
            <a
              href="https://play.google.com/store/apps/details?id=com.unacademyapp&referrer=utm_source%3DFooter%26utm_medium%3DWebApp%26utm_campaign%3DFooter%26"
              key="playstore"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleGooglePlayIconClick}
            >
              <img src={getImage('playStore_resized.svg')} alt="playstore" />
            </a>
            {/* <a
              href="https://apps.apple.com/in/app/unacademy-learning-app/id1342565069?referrer%3Dutm_source%253DFooter%2526utm_medium%253DWebApp%2526utm_campaign%253DFooter%2526"
              key="appstore"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={Appstore} alt="appstore" />
            </a> */}
          </AppsWrapper>
        </Content>
        <FooterAsset src={footerData?.image} alt="footer-asset" />
      </Wrapper>
      {isMobile && (
        <BgImageMobile
          src={getImage('combat/bottom-footer.svg')}
          alt="bottom footer cloud"
        />
      )}
    </FooterWrapper>
  );
};

export default CombatFooter;

CombatFooter.propTypes = {
  goalUID: PropTypes.string.isRequired
};
